import $ from 'jquery';
import html2canvas from 'html2canvas';
import { throttle } from './utils';
import { fbShare, twShare, dcShare, nvShare } from './share';
let base64 = '';
const shareContent = $('.j-canvas-container').get(0);

export const generateScreenshot = async () => {
  if (window.platform.isPhone()) {
    // 获取设备像素比 最大6
    let scale = window.devicePixelRatio || 1;
    // 获取需要截图的元素
    let element = document.getElementById("canvas");
    // 计算需要截图的区域
    let rect = element.getBoundingClientRect();
    let x = rect.left * scale;
    let y = rect.top * scale;
    let width = rect.width * scale;
    let height = rect.height * scale;
    x = 0;
    y = 0;
    // 截图并缩放
    html2canvas(element, {
      scale: scale,
      x: x,
      y: y,
      width: width,
      height: height,
      useCORS: true,
      allowTaint: false,
    }).then(function (canvas) {
      let context = canvas.getContext("2d");
      let imageData = context.getImageData(0, 0, width * scale, height * scale);
      canvas.width = width;
      canvas.height = height;
      context.putImageData(imageData, 0, 0);
      base64 = canvas.toDataURL();
      // 处理截图后的数据
      $('.j-shareImg').attr('src', base64).show();
    });
  } else {
    // 设置放大倍数
    const scale = window.platform.isPhone() ? 4 : 1;
    const opts = {
      scale,
      useCORS: true,
      allowTaint: false,
    };
    await html2canvas(shareContent, opts).then(res => {
      base64 = res.toDataURL('image/png', 1);
      $('.j-shareImg').attr('src', base64).show();
    });
  }

  $('.j-save-img-btn').on('click', function () { 
    savaPic(base64);
  });
  $('.j-fb-share-btn').on('click', function () {
    fbShare();
  });
  $('.j-dc-share-btn').on('click', function () {
    dcShare();
  });
  $('.j-tw-share-btn').on('click', function () {
    twShare();
  });
  $('.j-nv-share-btn').on('click', function () {
    nvShare();
  }); 
};

const savaPic = throttle(base64data => {
  let saveA = document.createElement('a');
  $('.j-temp').html('').get(0).appendChild(saveA);
  saveA.href = base64data;
  saveA.download = 'pnskfsquadron' + new Date().getTime();
  saveA.target = '_self';
  saveA.click();
},2000);